import React, { FC } from 'react';
import { PortalDialog } from '@component/Portal';
import { Modal } from '@app/react/uikit/Modal';

export interface DeleteDesignDialogProps {
    thumbnail?: React.ReactElement;
    isShow?: boolean;
    delBtnProps?: React.HTMLAttributes<HTMLButtonElement>;
    cancelBtnProps?: React.HTMLAttributes<HTMLButtonElement>;
}

export const DeleteDesignDialog: FC<DeleteDesignDialogProps> = (props) => {
    const {
        thumbnail, isShow = false, delBtnProps, cancelBtnProps,
    } = props;

    const title = 'このデザインを削除しようとしていますが、よろしいですか？';
    const msg = '一度削除したデザインは元に戻せませんのでご了承ください。';

    return (
        <PortalDialog className="delete-design-dialog">
            <Modal show={isShow} setShow={() => false}>
                <span className="title">{title}</span>
                <span className="sub-title">{msg}</span>

                <div className="disable-touch" role="img">
                    {thumbnail}
                </div>

                <div className="footer">
                    <button type="button" className="btn delete" {...delBtnProps}>
                        削除する
                    </button>
                    <button type="button" className="btn cancel" {...cancelBtnProps}>
                        キャンセル
                    </button>
                </div>
            </Modal>
        </PortalDialog>
    );
};
